import {
  FaBalanceScale,
  FaBroadcastTower,
  FaCalendarCheck,
  FaChartBar,
  FaCheckCircle,
  FaClipboardList,
  FaDesktop,
  FaFileExcel,
  FaLayerGroup,
  FaMedal,
  FaPlayCircle,
  FaQrcode,
  FaRandom,
  FaSitemap,
  FaTrophy,
  FaUserFriends,
  FaUsers,
  FaUserTie,
  FaWeight,
} from "react-icons/fa";

export const TOURNAMENT_OVERVIEW_FEATURES = [
  {
    icon: FaCalendarCheck,
    title: "Préparation centralisée",
    description:
      "Créez la compétition, définissez les catégories, les tapis et les règles d’organisation depuis un seul espace.",
  },
  {
    icon: FaFileExcel,
    title: "Inscriptions simplifiées",
    description:
      "Importez les compétiteurs depuis un fichier Excel ou laissez les clubs invités inscrire directement leurs judokas.",
  },
  {
    icon: FaBalanceScale,
    title: "Pesées et présences",
    description:
      "Contrôlez les présences, les poids réels et les changements de catégorie avant la répartition.",
  },
  {
    icon: FaBroadcastTower,
    title: "Résultats en direct",
    description:
      "Diffusez l’avancement, les résultats et les podiums auprès des coachs et du public.",
  },
];

export const TOURNAMENT_OVERVIEW_CHECKS = [
  "Aucune application à installer sur les appareils",
  "Utilisation possible sur ordinateur, tablette et mobile",
  "Plusieurs tables d’arbitrage peuvent travailler simultanément",
  "Les résultats sont mis à jour au fil des combats",
];

export const TOURNAMENT_WORKFLOW_STEPS = [
  {
    icon: FaCalendarCheck,
    title: "Création du tournoi",
    description:
      "Renseignez les informations générales, la date, le lieu, les catégories, le nombre de tapis et les paramètres de compétition.",
  },
  {
    icon: FaFileExcel,
    title: "Ajout des compétiteurs",
    description:
      "Importez un fichier Excel, ajoutez les combattants manuellement ou ouvrez les inscriptions aux clubs invités.",
  },
  {
    icon: FaWeight,
    title: "Pesées et présences",
    description:
      "Validez les présents, corrigez les poids et ajustez les catégories avant de lancer les répartitions.",
  },
  {
    icon: FaRandom,
    title: "Répartition automatique",
    description:
      "Répartissez les compétiteurs en poules ou en tableaux selon leur âge, leur poids, leur grade et les règles choisies.",
  },
  {
    icon: FaSitemap,
    title: "Affectation aux tapis",
    description:
      "Envoyez les poules et tableaux vers les tapis disponibles et organisez l’ordre de passage des combattants.",
  },
  {
    icon: FaPlayCircle,
    title: "Suivi des combats",
    description:
      "Les tables d’arbitrage lancent les combats, saisissent les scores et désignent les vainqueurs.",
  },
  {
    icon: FaDesktop,
    title: "Scoreboard public",
    description:
      "Affichez le tableau de score sur un écran secondaire pendant que la table conserve son interface de gestion.",
  },
  {
    icon: FaMedal,
    title: "Résultats et podiums",
    description:
      "Les classements sont calculés automatiquement et peuvent être publiés avec les statistiques et photos de podiums.",
  },
];

export const TOURNAMENT_AUDIENCES = [
  {
    key: "organizer",
    icon: FaTrophy,
    eyebrow: "Pilotage global",
    title: "Organisateurs",
    accent:
      "from-orange-500 to-amber-500",
    items: [
      "Création et paramétrage des compétitions",
      "Importation des compétiteurs",
      "Contrôle des pesées et des présences",
      "Répartition sur les tapis",
      "Suivi global de l’avancement",
      "Publication des résultats et podiums",
    ],
  },
  {
    key: "clubs",
    icon: FaUserFriends,
    eyebrow: "Inscriptions et suivi",
    title: "Clubs et coachs",
    accent:
      "from-blue-600 to-cyan-500",
    items: [
      "Inscription et désinscription des judokas",
      "Consultation des tapis affectés",
      "Suivi des combats terminés",
      "Accès aux résultats en temps réel",
      "Consultation des classements",
      "Accès sans application à installer",
    ],
  },
  {
    key: "tables",
    icon: FaUserTie,
    eyebrow: "Gestion des combats",
    title: "Tables d’arbitrage",
    accent:
      "from-emerald-500 to-teal-500",
    items: [
      "Visualisation des combats à lancer",
      "Saisie des scores et pénalités",
      "Désignation automatique du vainqueur",
      "Mise à jour des poules et tableaux",
      "Affichage sur écran secondaire",
      "Suivi adapté à chaque tapis",
    ],
  },
  {
    key: "public",
    icon: FaUsers,
    eyebrow: "Informations en direct",
    title: "Public",
    accent:
      "from-violet-600 to-fuchsia-500",
    items: [
      "Accès aux résultats par QR code",
      "Consultation des tapis et catégories",
      "Suivi de l’avancement du tournoi",
      "Affichage des classements",
      "Visualisation des podiums",
      "Accès depuis un simple navigateur",
    ],
  },
];

export const TOURNAMENT_BENEFITS = [
  {
    icon: FaClipboardList,
    value: "1 interface",
    label:
      "pour toutes les étapes du tournoi",
  },
  {
    icon: FaLayerGroup,
    value: "Poules & tableaux",
    label:
      "adaptés à différents formats",
  },
  {
    icon: FaQrcode,
    value: "QR Code",
    label:
      "pour les résultats publics",
  },
  {
    icon: FaChartBar,
    value: "Statistiques",
    label:
      "et classements automatiques",
  },
];

export const TOURNAMENT_FINAL_ARGUMENTS = [
  {
    icon: FaCheckCircle,
    text: "L’organisateur garde une vision globale de la compétition.",
  },
  {
    icon: FaCheckCircle,
    text: "Chaque table gère uniquement les combats de son tapis.",
  },
  {
    icon: FaCheckCircle,
    text: "Les coachs suivent leurs judokas sans solliciter la table centrale.",
  },
  {
    icon: FaCheckCircle,
    text: "Le public consulte les résultats directement depuis son téléphone.",
  },
];